const guidedConvertationsWidgetReducers = {
  setGuidedConvertationsWidgetData: (state, action) => {
    state.guidedConvertationsWidgetData = action.payload;
  },
  setGuidedConversationsApplicable: (state, action) => {
    state.data.guidedConversationsApplicable = action.payload;
  }
}

export default guidedConvertationsWidgetReducers;